export const defaultRowsPerPageOptions = [50, 100, 150, 200]

export const EMPTY_COLUMN_FALLBACK = "-"
